export default __webpack_public_path__ + "static/media/test.04ba4450.svg";